"use client"

import {
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
} from "@mui/material"
import { MapPin, Home } from "lucide-react"

const textColor = "#0d2561"
const itextColor = "#707070"

export function BusinessInsightsWidget() {
  const regionalData = [
    { region: "New York", closed: 12 },
    { region: "Arizona", closed: 8 },
    { region: "California", closed: 15 },
    { region: "Florida", closed: 10 },
    { region: "Texas", closed: 7 },
  ]

  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1, fontSize:'1.20rem' }}>
          Business Insights
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Properties started and closed by region.
        </Typography>

        <Stack spacing={2} mb={19}>
          {regionalData.map((item, index) => (
            <Stack key={index} direction="row" spacing={2} alignItems="center">
              <MapPin className="h-5 w-5" color="#0d2561" width='20px' height='20px'/>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 500, color: textColor }}>
                  {item.region}
                </Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Home className="h-3 w-3" color="#707070" width='14px' height='14px' />
                  <Typography variant="body2" sx={{ color: itextColor }}>
                    {item.closed} properties closed
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  )
}
